<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="full-body">
            <div v-if="this.$route.params.slug === 'react-native'">
                <div v-for="(question, index) in randomQuestionsRN" :key="index">
                    <div v-show="index === quesIndex">
                        <QuestionElement @timefinished="timeUp" @checked="answerSelected"
                            :currIndex="quesIndex + 1"
                            :totalQuestions="quizRN.length"
                            :source="question.code" 
                            :ques="question.ques"
                            :options="question.options"
                            :allottedTime="question.time"
                            :offset="0">
                            
                        </QuestionElement>

                        <a class="btn btn-success" id="submit-work" v-on:click="answerSubmitted(question, quizRN.length)">
                            Submit
                        </a>
                        <br><br><br><br><br>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import QuestionElement from './QuestionElement.vue'
import firebase from '../services/firebase'
import NavBarLight from '../components/NavBarLight.vue'
import _ from 'lodash'

export default {
    name: 'QuizStart',
    components: {
        QuestionElement,
        NavBarLight
    },
    data: function() {
        return {
            quesIndex: 0,
            comeBefore: false,
            quizRN: [],
            countTime: Math.trunc((new Date()).getTime() / 1000) + 900000,
            start: Math.trunc((new Date()).getTime() / 1000),
            now: Math.trunc((new Date()).getTime() / 1000),
            selected: '',
            correct: 0,
            wrong: 0,
            total: 0,
            allow: false
        }
    },
    mounted: function() {
        window.setInterval(() => {
            this.now = Math.trunc((new Date()).getTime() / 1000)
        }, 1000);
    },
    firebase: {
        quizRN: firebase.database().ref('quizzes/React Native Quiz'),
        quizAndroid: firebase.database().ref('quizzes/Android Quiz')
    },
    computed: {
        randomQuestionsRN: function() {
            return _.shuffle(this.quizRN);
        }
    },
    methods: {
        answerSubmitted: function(quesObj, total_ques) {
            
            var quesResult = "wrong";
            if (this.selected === quesObj.ans) {
                quesResult = "correct";
                this.correct++;
            } else {
                quesResult = "wrong";
                this.wrong++;
            }

            this.total = total_ques;
            this.quesIndex++;

            var quiz_slug = this.$route.params.slug;
            var ques_index = this.quesIndex;
            var selected = this.selected;
            var allow = this.allow;


            //Write question performance to db
            firebase.database().ref("/submissions/quizzes/" + quiz_slug + 
                        "/" + firebase.auth().currentUser.uid).once('value', (snapshot) => {
                
                console.log("snapshot exists is " + snapshot.exists());
                if (!snapshot.exists() || allow) {
                    this.allow = true;
                    firebase.database().ref("submissions/quizzes/" + quiz_slug + 
                            "/" + firebase.auth().currentUser.uid + "/" + ques_index).set({
                        question: quesObj.ques,
                        answer: selected,
                        correct_answer: quesObj.ans,
                        result: quesResult
                    });
                }
                
            });


            if (this.total === this.quesIndex) {
                var total_score = (this.correct)*100/(this.correct + this.wrong);
                var ans_correct = this.correct;
                var ans_wrong = this.wrong;
                this.$router.push(this.$route.path + '/done');

                mixpanel.track("quiz ended", {
                    "user_id": firebase.auth().currentUser.uid,
                    "quiz_name": this.$route.params.slug,
                    "email": firebase.auth().currentUser.email,
                    "score": total_score,
                    "correct": ans_correct,
                    "wrong": ans_wrong
                });

                firebase.database().ref("submissions/quizzes/" + quiz_slug + 
                        "/" + firebase.auth().currentUser.uid + "/result").once('value', function(snapshot) {

                    
                    console.log("snapshot exists is " + snapshot.exists());
                    if (!snapshot.exists()) {
                    
                        firebase.database().ref("/submissions/quizzes/" + quiz_slug + 
                        "/" + firebase.auth().currentUser.uid + "/result").set({
                            score: total_score,
                            correct: ans_correct,
                            wrong: ans_wrong
                        });
                    }
                    
                });
                
            }
        },
        answerSelected: function(val_selected) {
            this.selected = val_selected;
            console.log("answer selected in answerSelected is " + this.selected);
        },
        timeUp: function(index, total) {
            this.selected = '';
            this.answerSubmitted(index, total);
        },
        setComeBefore: function() {
            this.comeBefore = true;
        }
    }
}
</script>


<style scoped>

    .questions-num {
        margin-left: 0%;
    }

    .full-body {
        padding-top:40px;
        padding-bottom: 0px;
        font-family: Avenir;
    }

    .heading {
        margin-top: 0px;
        font-size: 1.55rem;
    }


    #submit-work {
        margin-top:1%;
        margin-bottom:15%;
		padding-top:9px;
		padding-bottom:9px;
		padding-left:6%;
		padding-right:6%;
        justify-content: center;
        align-self: center;
        margin:auto;
		width:20%;
		background-color:#f25792;
		border-color:#f25792;
		color:#fff;
        font-size:0.96rem;
        cursor: pointer;
    }

    .no-display {
        display: none;
    }

</style>
